import React from "react";
import { motion } from "framer-motion";

/**
 * Wraps children in a fade + slide-up reveal that plays once
 * when the element scrolls into view.
 */
export default function Reveal({
    children,
    delay = 0,
    y = 28,
    className = "",
    as = "div",
    once = true,
}) {
    const MotionTag = motion[as] || motion.div;

    return (
        <MotionTag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.25 }}
            transition={{ duration: 0.6, delay, ease: [0.22, 0.9, 0.32, 1] }}
        >
            {children}
        </MotionTag>
    );
}

export const staggerContainer = {
    hidden: {},
    show: {
        transition: {
            staggerChildren: 0.08,
        },
    },
};

export const staggerItem = {
    hidden: { opacity: 0, y: 24 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: [0.22, 0.9, 0.32, 1] },
    },
};
